import {
    SOCIETY_GET_COMPLAINTS_LIST,
    SOCIETY_GET_COMPLAINT_DETAILS,
    SOCIETY_CREATE_COMPLAINT,
    SOCIETY_UPDATE_COMPLAINT,
    SOCIETY_DELETE_COMPLAINT,
    SOCIETY_CHANGE_COMPLAINT_STATUS,
    SOCIETY_ASSIGN_COMPLAINT,
    SOCIETY_ADD_COMPLAINT_COMMENT,
    SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS,
    SOCIETY_DELETE_COMPLAINT_ATTACHMENT,
    SOCIETY_GET_COMPLAINT_ENUMS,
    SOCIETY_GET_COMPLAINT_STATS,
    SOCIETY_GET_COMPLAINT_CATEGORIES,
    SOCIETY_CREATE_COMPLAINT_CATEGORY,
    SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES,
    SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI,
    SOCIETY_UPDATE_COMPLAINT_CATEGORY,
    SOCIETY_DELETE_COMPLAINT_CATEGORY,
    SOCIETY_GET_EMPLOYEE_COMPLAINTS,
    SOCIETY_RATE_COMPLAINT,
    SOCIETY_GET_COMPLAINT_AUDIT_LOG,
} from '../../index.types';

export const getComplaintsList = (data) => ({ type: SOCIETY_GET_COMPLAINTS_LIST, data });
export const getComplaintDetails = (data) => ({ type: SOCIETY_GET_COMPLAINT_DETAILS, data });
export const createComplaint = (data) => ({ type: SOCIETY_CREATE_COMPLAINT, data });
export const updateComplaint = (data) => ({ type: SOCIETY_UPDATE_COMPLAINT, data });
export const deleteComplaint = (data) => ({ type: SOCIETY_DELETE_COMPLAINT, data });
export const changeComplaintStatus = (data) => ({ type: SOCIETY_CHANGE_COMPLAINT_STATUS, data });
export const assignComplaint = (data) => ({ type: SOCIETY_ASSIGN_COMPLAINT, data });
export const addComplaintComment = (data) => ({ type: SOCIETY_ADD_COMPLAINT_COMMENT, data });
export const uploadComplaintAttachments = (data) => ({ type: SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS, data });
export const deleteComplaintAttachment = (data) => ({ type: SOCIETY_DELETE_COMPLAINT_ATTACHMENT, data });
export const getComplaintEnums = (data) => ({ type: SOCIETY_GET_COMPLAINT_ENUMS, data });
export const getComplaintStats = (data) => ({ type: SOCIETY_GET_COMPLAINT_STATS, data });

export const getComplaintCategories = (data) => ({ type: SOCIETY_GET_COMPLAINT_CATEGORIES, data });
export const createComplaintCategory = (data) => ({ type: SOCIETY_CREATE_COMPLAINT_CATEGORY, data });
export const bulkCreateComplaintCategories = (data) => ({ type: SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES, data });
export const getComplaintCategoriesMulti = (data) => ({ type: SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI, data });
export const updateComplaintCategory = (data) => ({ type: SOCIETY_UPDATE_COMPLAINT_CATEGORY, data });
export const deleteComplaintCategory = (data) => ({ type: SOCIETY_DELETE_COMPLAINT_CATEGORY, data });

export const getEmployeeComplaints = (data) => ({ type: SOCIETY_GET_EMPLOYEE_COMPLAINTS, data });
export const rateComplaint = (data) => ({ type: SOCIETY_RATE_COMPLAINT, data });
export const getComplaintAuditLog = (data) => ({ type: SOCIETY_GET_COMPLAINT_AUDIT_LOG, data });
